import { render, staticRenderFns } from "./DashboardCriticalityCard.vue?vue&type=template&id=40e860d5&"
import script from "./DashboardCriticalityCard.vue?vue&type=script&lang=js&"
export * from "./DashboardCriticalityCard.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCriticalityCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports